










































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'
import { Watch } from 'vue-property-decorator'

import DigitalCurrency6AccountUserProfilePicture from '../../../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-6-account-user-profile-picture.vue'

import Input3InputWithUpdateButton from '../../../../../../html-components-type-1-basic/basic-type-3-input/input-3-input-with-update-button.vue'
import UserInterface3ErrorMessage from '../../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-3-error-message.vue'
import Input4PropertyIdMapper from '../../../../../../html-components-type-1-basic/basic-type-3-input/input-4-property-id-mapper.vue'
import UserInterface5AreYouSure from '../../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-5-are-you-sure.vue'


import {
  TRANSACTION_PROMOTION_TYPE_LIST,
  PRODUCT_RESOURCE_TYPE_LIST,
  JOB_EMPLOYMENT_POSITION_TYPE_LIST,
  CURRENCY_EXCHANGE_CURRENCY_TYPE_LIST,
  DIGITAL_CURRENCY_ALTERNATIVE_FEATURE_LIST
} from '../../../../../../html-components-type-1-basic/basic-type-2-digital-currency/service-for-helper-constants/helper-constants-2'


// import { projectVariables } from '../../../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


const namespace = 'digitalCurrency'

@Component({
  components: {
    DigitalCurrency6AccountUserProfilePicture,
    Input3InputWithUpdateButton,
    UserInterface3ErrorMessage,
    Input4PropertyIdMapper,
    UserInterface5AreYouSure
  }
})
class AccountInformationSettings1ServiceAccountSettings extends Vue {
  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyAccountDescription', { namespace }) getDigitalCurrencyAccountDescription?: any

  @Action('deleteDigitalCurrencyAccount', { namespace }) deleteDigitalCurrencyAccount?: any
  @Action('updateDigitalCurrencyAccount', { namespace }) updateDigitalCurrencyAccount?: any
  @Action('updateDigitalCurrencyAccountDescription', { namespace }) updateDigitalCurrencyAccountDescription?: any

  showAreYouSureDeleteDialog: boolean = false
  areYouSureDeleteDialogIconId = 'delete'
  areYouSureDeleteDialogTitle = 'Delete Account'
  areYouSureDeleteDialogMessage = `Are you sure you wish to delete this account?`
  areYouSureDeleteDialogHeaderCssClass = 'error'

  showErrorMessage: boolean = false
  errorMessage: string = 'errorMessage'

  profilePictureFileList: any = []

  BASIC_DESCRIPTION = 'basic-description'
  TRANSACTION_RESOURCE_CENTER_DESCRIPTION = 'transaction-resource-center-description'
  PRODUCT_RESOURCE_CENTER_DESCRIPTION = 'product-resource-center-description'
  JOB_EMPLOYMENT_RESOURCE_CENTER_DESCRIPTION = 'job-employment-resource-center-description'
  CURRENCY_EXCHANGE_RESOURCE_CENTER_DESCRIPTION = 'currency-exchange-resource-center-description'
  DIGITAL_CURRENCY_ALTERNATIVE_RESOURCE_CENTER_DESCRIPTION = 'digital-currency-alternative-resource-center-description'

  TRANSACTION_PROMOTION_TYPE_LIST: string[] = TRANSACTION_PROMOTION_TYPE_LIST

  get PRODUCT_RESOURCE_TYPE_LIST () {
    return PRODUCT_RESOURCE_TYPE_LIST.map(productResource => productResource.productResourceName)
  }

  get JOB_EMPLOYMENT_POSITION_TYPE_LIST () {
    return JOB_EMPLOYMENT_POSITION_TYPE_LIST.map(jobEmploymentPosition => jobEmploymentPosition.jobEmploymentPositionName)
  }

  get CURRENCY_EXCHANGE_CURRENCY_TYPE_LIST () {
    return CURRENCY_EXCHANGE_CURRENCY_TYPE_LIST.map(currencyExchangeCurrency => currencyExchangeCurrency.currencyExchangeCurrencyName)
  }

  get DIGITAL_CURRENCY_ALTERNATIVE_FEATURE_LIST () {
    return DIGITAL_CURRENCY_ALTERNATIVE_FEATURE_LIST.map(digitalCurrencyAlternativeFeature => digitalCurrencyAlternativeFeature.digitalCurrencyAlternativeFeatureName)
  }

  @Watch('profilePictureFileList') updateProfilePictureFileList () {
    this.updateAccount('accountProfilePictureUrl', this.profilePictureFileList)
  }

  async deleteAccount () {
    this.showAreYouSureDeleteDialog = false
    this.scrollToTop()

    this.deleteDigitalCurrencyAccount(this.getActiveDigitalCurrencyAccount.accountId)
    .catch((errorMessage: any) => {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
    })
  }

  updateAccount (propertyId: string, propertyValue: any) {
    this.updateDigitalCurrencyAccount({
      digitalCurrencyAccountId: this.getActiveDigitalCurrencyAccount.accountId,
      propertyId,
      propertyValue
    }).catch((errorMessage: any) => {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
    })
  }

  updateAccountDescription (descriptionType: string, propertyId: string, propertyValue: any) {
    this.updateDigitalCurrencyAccountDescription({
      digitalCurrencyAccountId: this.getActiveDigitalCurrencyAccount.accountId,
      descriptionType,
      propertyId,
      propertyValue
    }).catch((errorMessage: any) => {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
    })
  }

  scrollToTop () {
    const titleElement = this.$refs['page-title'] as HTMLElement
    const titleElementTopPosition = titleElement.getBoundingClientRect().top + window.scrollY
    window.scrollTo({ top: titleElementTopPosition - 800, behavior: 'smooth' })
  }

  // Input Validation Rules

  requireInput (inputValue: any) {
    return !!inputValue || 'Must have input value'
  }

  requireLessThanN1Characters (inputValue: any) {
    return inputValue.length <= 30 || 'Must have less than 30 characters'
  }

  requireLessThanN2Characters (inputValue: any) {
    return inputValue.length <= 20 || 'Must have less than 20 characters'
  }

  requireAlphanumericCharacters (inputValue: any) {
    const regularExpressionPattern = /^([a-zA-Z0-9_-]+)$/

    return regularExpressionPattern.test(inputValue) || 'Must contain alphanumeric characters only'
  }

}

export default AccountInformationSettings1ServiceAccountSettings

